import { AdExchangeComponent } from '@/features/advertisement';
import useUnifiedAdNative, { UnifiedAdNativeType } from '@/hooks/advertisement/useUnifiedAdNative';
import { AdPageType } from '@/models/ad/list';
import AdropQnaNative from '@/shared/ui/AdropQnaNative';
import QnaNativeSkeleton from '@/shared/ui/QnaNativeSkeleton';
import { Client } from '@/types/app';
import React, { useEffect } from 'react';

interface UnifiedAdQnaNativeProps {
  adPageType: AdPageType.QnaListNative | AdPageType.QnaHomeNative;
  client: Client;
  contextId?: string;
  fallbackContent?: React.ReactNode;
  className?: string;
  enabled?: boolean;
  onLoad?: () => void;
  onError?: (error: Error) => void;
  isShowAdBadge?: boolean;
}

const UnifiedAdQnaNative: React.FC<UnifiedAdQnaNativeProps> = (props) => {
  const enabled = props.enabled ?? true;
  const isShowAdBadge = props.isShowAdBadge ?? true;

  const { selectedAd, isLoading, handleAdExchangeExposureLog } = useUnifiedAdNative(
    props.adPageType,
    props.client,
    enabled,
    props.contextId,
    'ko_KR'
  );

  useEffect(() => {
    if (selectedAd.type !== UnifiedAdNativeType.None) {
      props.onLoad?.();
    }
  }, [selectedAd]);

  // 로딩 상태 렌더링
  if (isLoading) {
    return <QnaNativeSkeleton className={props.className} isShowAdBadge={isShowAdBadge} />;
  }

  // 에드컨트롤 광고 렌더링
  if (selectedAd.type === UnifiedAdNativeType.AdControl) {
    return (
      <AdropQnaNative
        adData={selectedAd.data}
        className={props.className}
        onLoad={props.onLoad}
        onError={props.onError}
        fallback={props.fallbackContent}
        isShowAdBadge={isShowAdBadge}
      />
    );
  }

  // 내부광고 렌더링
  if (selectedAd.type === UnifiedAdNativeType.AdExchange) {
    return (
      <AdExchangeComponent
        bannerAdExchange={selectedAd.data}
        onImpressionLog={handleAdExchangeExposureLog}
        fallback={props.fallbackContent}
      >
        <AdExchangeComponent.QnaAd className={props.className} isShowAdBadge={isShowAdBadge} />
      </AdExchangeComponent>
    );
  }

  return props.fallbackContent;
};

export default UnifiedAdQnaNative;
